import { setBlockTracking as _setBlockTracking, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a3d62d8")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _cache[1] || (
    _setBlockTracking(-1),
    _cache[1] = _createVNode("a", {
      href: _ctx.href,
      rel: "noopener",
      target: "_blank"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, ["href"]),
    _setBlockTracking(1),
    _cache[1]
  )
})